import { render, staticRenderFns } from "./CargosGuia.vue?vue&type=template&id=ff157e6c&scoped=true&"
import script from "./CargosGuia.vue?vue&type=script&lang=js&"
export * from "./CargosGuia.vue?vue&type=script&lang=js&"
import style0 from "./CargosGuia.vue?vue&type=style&index=0&id=ff157e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff157e6c",
  null
  
)

export default component.exports